import { OriginationsReportConfig } from "./originations-report.config";

export const Configs : any = {
    'Vendas': OriginationsReportConfig,
}
